import React, { useEffect } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
export const REACT_APP_SIGNUP_GOOGLE_SITE_KEY = process.env.REACT_APP_SIGNUP_GOOGLE_SITE_KEY;

if (!REACT_APP_SIGNUP_GOOGLE_SITE_KEY)
    throw new Error('REACT_APP_SIGNUP_GOOGLE_SITE_KEY is not set');

const useStyles = makeStyles(() =>
    createStyles({
        reCaptchaStyles: {
            fontSize: 12,
            textAlign: 'left',
            letterSpacing: 0,
            '& a': {
                textDecoration: 'none',
            },
        },
    }),
);

const ReCaptcha: React.FC<{ className?: string }> = ({ className }) => {
    useEffect(() => {
        const script = document.createElement('script');

        script.src = `https://www.google.com/recaptcha/api.js?render=${REACT_APP_SIGNUP_GOOGLE_SITE_KEY}`;
        script.async = true;
        script.defer = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    const { reCaptchaStyles } = useStyles();
    return (
        <p className={`${reCaptchaStyles} ${className}`}>
            This site is protected by reCAPTCHA and the Google{' '}
            <a
                href="https://policies.google.com/privacy"
                rel="noopener noreferrer"
                target="_blank"
            >
                Privacy Policy
            </a>{' '}
            and{' '}
            <a
                href="https://policies.google.com/terms"
                rel="noopener noreferrer"
                target="_blank"
            >
                Terms of Service
            </a>{' '}
            apply.
        </p>
    );
};

export default ReCaptcha;
